module.exports = "/static/assets/6bcb77943c4f72322e154302a761f456.png";